<template>
  <section class="blood-group-section mt-5">
    <h2>จำนวนสมาชิกทั้งหมดแบ่งตาม Blood Group<br>ในเครือข่าย Smart Pet Blood Bank</h2>
    <container>
      <div class="col-sm-12 col-md-6 dog-group">
        <div class="row">
          <div class="col-2">
            <img class="blood-group-img" src="@/assets/other/dog-outline.png" alt="dog outline red">
          </div>
          <div class="col-10">
            <bar-chart
              :bloodData="dogBloodGroup"
              :chartHeight="250"
              :unitLabel="chartUnitLabel"/>
          </div>
        </div>
      </div>
      <div class="col-sm-12 col-md-6 cat-group">
        <div class="row">
          <div class="col-10">
            <bar-chart
              :bloodData="catBloodGroup"
              :chartHeight="250"
              :unitLabel="chartUnitLabel"/>
          </div>
          <div class="col-2">
            <img class="blood-group-img" src="@/assets/other/cat-outline.png" alt="cat outline red">
          </div>
        </div>
      </div>
    </container>
  </section>
</template>

<script>
import Container from '@/components/Container.vue'
import BarChart from '@/components/BarChart.vue'

export default {
  name: 'BloodGroupSection',
  props: ['pets'],
  components: {
    Container,
    BarChart
  },
  data () {
    return {
      dogBloodGroup: [],
      catBloodGroup: [],
      chartUnitLabel: 'ตัว'
    }
  },
  methods: {
    async fetchData () {
      this.$http.get('pet/heros/blood/report/').then((response) => {
        let results = response.data.result
        results.forEach(result => {
          let bloods = result.blood
          bloods.forEach(blood => {
            if (result.pet_type === 'dog') {
              this.dogBloodGroup.push({
                type: blood.blood_group,
                units: blood.count,
                barHeight: 0
              })
            } else if (result.pet_type === 'cat') {
              this.catBloodGroup.push({
                type: blood.blood_group,
                units: blood.count,
                barHeight: 0
              })
            }
          }, this)
        }, this)
      })
    }
  },
  async created () {
    this.fetchData()
  }
}
</script>

<style scoped lang="scss">
.blood-group-section {
  padding: 2rem 0;
  .cat-group {
    margin-top: 1rem;
  }
  h2 {
    text-align: center;
    margin-bottom: 1rem;
    padding: 0 1rem;
    font-size: $h3-font-size;
  }
  .blood-group-img {
    bottom: 3.5rem;
    position: absolute;
    left: 0;
    width: 100%;
  }
}
@media (min-width: map-get($grid-breakpoints, "sm")) {
  .blood-group-section {
    h2 {
      margin-bottom: 2rem;
      font-size: $h2-font-size;
    }
  }
}
@media (min-width: map-get($grid-breakpoints, "md")) {
  .blood-group-section {
    .cat-group {
      margin-top: 0;
    }
    .dog-group {
      border-right: 1px solid $gray-500;
    }
  }
}
</style>
